// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /chat/list-mine.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeChatListMineBody,
  typeChatListMineOutput200,
} from "../../sdk/chat/postChatListMine";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildChatListMineQueryKey(
  payload: typeChatListMineBody,
): string[] {
  const queryKeySegments: string[] = [];
  if (typeof payload.chatType !== "undefined") {
    queryKeySegments.push(`chatType:${JSON.stringify(payload.chatType)}`);
  }
  if (typeof payload.cursor !== "undefined") {
    queryKeySegments.push(`cursor:${JSON.stringify(payload.cursor)}`);
  }
  if (typeof payload.limit !== "undefined") {
    queryKeySegments.push(`limit:${JSON.stringify(payload.limit)}`);
  }
  return ["post:chat:chatListMine", "svc:messaging-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeChatListMineOutput200,
    unknown,
    typeChatListMineOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useChatListMine(
  payload: typeChatListMineBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildChatListMineQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postChatListMine(payload),
    ...resolvedOptions,
  });
}
